module.exports = __webpack_public_path__ + "static/media/img1.728a61a5.jpg";